// @flow
import React, { Component } from 'react';
import { Form, FormGroup, Col, ControlLabel } from 'react-bootstrap';

import isEqual from './util/compareRadioObject';
import local from '../../../../locales';
import RadioStationsGroup from './components/RadioStationsGroup/RadioStationsGroup';
import radioStations from './radios.json';

class Radio extends Component<{user: Object}, {selectedStations: Array<Object>}> {

  constructor(props: Object) {
    super(props);

    const modules = this.props.user.modules;
    const list = (modules.radio) ? modules.radio.list : [];

    this.state = {
      checkedStations: list,
    };
  }

  onRadioSelectionChanged(list: Array<Object>) {
    const checkedStations = this.state.checkedStations;

    list.forEach((changedStation: Object) => {
      if (changedStation.state) {
        if (checkedStations.some(r => isEqual(r, changedStation.data)) === false) {
          checkedStations.push(changedStation.data);
        }
      } else {
        const index = checkedStations.findIndex(r => isEqual(r, changedStation.data));
        checkedStations.splice(index, 1);
      }
    });

    this.setState({ checkedStations });
  }

  save(user: Object): Object {
    const newUser = user;

    newUser.modules.radio = { list: this.state.checkedStations };
    return newUser;
  }

  generateGroupsList(): React.Element<any> {
    const list = [];
    radioStations.forEach((group) => {
      list.push(<RadioStationsGroup
        radioGroup={group}
        checkedStations={this.state.checkedStations}
        key={group.language}
        onChange={(l: Array<Object>) => this.onRadioSelectionChanged(l)}
      />);
    });

    return list;
  }

  render() {
    return (<div>
      <h4>{local.radio}</h4>
      <Form horizontal>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={2}>
            {local.radioStations}
          </Col>
          <Col sm={10}>
            {this.generateGroupsList()}
          </Col>
        </FormGroup>
      </Form>
    </div>);
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Radio/Radio.js